import { render, staticRenderFns } from "./showList.vue?vue&type=template&id=80ae321e&scoped=true"
import script from "./showList.vue?vue&type=script&lang=js"
export * from "./showList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ae321e",
  null
  
)

export default component.exports